import { ErrorPageDetailsTypes } from '../../../types/errorPageDetailsTypes';

export const errorPageDetailsConstant: ErrorPageDetailsTypes = {
  description:
    'Что-то пошло не так. Пожалуйста, попробуйте еще раз через некоторое время.',
  title: 'Системная ошибка',
};
